/**
 * Typography reference:
 * https://www.figma.com/design/Jg4zxJvL7FptGKAeQcBMRr/Ready2Book-Design-System?node-id=78-16437&p=f&t=YPAjCNdCeqZSNvZc-0
 */
export default Object.freeze({
  h1: 'text-h1',
  h2: 'text-h2',
  h3: 'text-h3',
  h4: 'text-h4',
  h5: 'text-h5',
  h6: 'text-h6',

  largeBody: 'text-body-large',
  largeBodyBold: 'text-large-body-bold',
  smallBody: 'text-small-body',
  smallBodyBold: 'text-small-body-bold',

  largeButton: 'text-large-button',
  mediumButton: 'text-medium-button',
  smallButton: 'text-small-button',

  caption: 'text-caption',
  captionBold: 'text-caption-bold',
  smallCaption: 'text-small-caption',
})
